import React from 'react';

import {AdjustableColumns} from '@gisatcz/ptr-atoms';
import MainMapPanel from './MainMapPanel';
import VisualizationsPanel from './VisualizationsPanel';
import IntroOverlay from './IntroOverlay';

class App extends React.PureComponent {
	render() {
		return (
			<>
				<IntroOverlay />
				<AdjustableColumns
					fixed
					content={[
						{
							component: MainMapPanel,
							className: 'eo4sdDrrInsarVietnam20-main-map-panel',
						},
						{
							width: '35%',
							minWidth: '20rem',
							maxWidth: '35rem',
							className: 'eo4sdDrrInsarVietnam20-visualizations-panel',
							component: VisualizationsPanel,
						},
					]}
				/>
			</>
		);
	}
}

export default App;
